import React, { useCallback, useEffect, useMemo } from "react";
import * as Yup from "yup";
import { CourtContent } from "../../contents/htmlContent";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Row,
  Col,
  Modal,
  ModalBody,
  Input,
  FormGroup,
  Label,
  Button,
  Table,
  ModalFooter,
  Card,
  CardBody,
  Alert,
  ModalHeader,
  FormText,
} from "reactstrap";
import CreatableSelect from "react-select/creatable";
import { useDispatch, useSelector } from "react-redux";
import Capsual from "../capsual";
import Title from "../title";
import { Field } from "formik";
import "react-datepicker/dist/react-datepicker.css";
import Webcam from "react-webcam";
import { useDropzone } from "react-dropzone";
import Resizer from "react-image-file-resizer";
import { api } from "../../api/api";
import "react-phone-number-input/style.css";
import { useState } from "react";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import deletenew from "../../assets/images/deletenew.svg";
import moment from "moment";
import MultiSelector from "../multiSelector";
import { FormatObjects } from "../appointment/bookAppointment/utils";
import DatePicker from "react-datepicker";
import { toastr } from "react-redux-toastr";
import TypeScheduleTabs from "./typesScdule";
import DateIntervalSummary from "./dateIntervalSummary";
import DateIntervalPicker from "./dateIntervalPicker";
import {
  earlyCancelAllBookingsForUpdatedSlots,
  getBookingsForUpdatedSlots,
  getCourtDurations,
  getSlotsTypes,
  updateCourtSlots,
} from "../../redux/actions/api/apiAction";
import { ComonIcons } from "../../contents/commonIcons";
import DataTable from "react-data-table-component";
import { history } from "../../app/AppRouter";

const weekDays = [
  { id: 1, name: "Saturday" },
  { id: 2, name: "Sunday" },
  { id: 3, name: "Monday" },
  { id: 4, name: "Tuesday" },
  { id: 5, name: "Wednesday" },
  { id: 6, name: "Thursday" },
  { id: 7, name: "Friday" },
];

const timesArr = [
  { time: "6:00", value: "06:00" },
  { time: "6:15", value: "06:15" },
  { time: "6:20", value: "06:20" },
  { time: "6:30", value: "06:30" },
  { time: "6:40", value: "06:40" },
  { time: "6:45", value: "06:45" },
  { time: "6:50", value: "06:50" },

  { time: "7:00", value: "07:00" },
  { time: "7:15", value: "07:15" },
  { time: "7:20", value: "07:20" },
  { time: "7:30", value: "07:30" },
  { time: "7:40", value: "07:40" },
  { time: "7:45", value: "07:45" },
  { time: "7:50", value: "07:50" },

  { time: "8:00", value: "08:00" },
  { time: "8:15", value: "08:15" },
  { time: "8:20", value: "08:20" },
  { time: "8:30", value: "08:30" },
  { time: "8:40", value: "08:40" },
  { time: "8:45", value: "08:45" },
  { time: "8:50", value: "08:50" },

  { time: "9:00", value: "09:00" },
  { time: "9:15", value: "09:15" },
  { time: "9:20", value: "09:20" },
  { time: "9:30", value: "09:30" },
  { time: "9:40", value: "09:40" },
  { time: "9:45", value: "09:45" },
  { time: "9:50", value: "09:50" },

  { time: "10:00", value: "10:00" },
  { time: "10:15", value: "10:15" },
  { time: "10:20", value: "10:20" },
  { time: "10:30", value: "10:30" },
  { time: "10:40", value: "10:40" },
  { time: "10:45", value: "10:45" },
  { time: "10:50", value: "10:50" },

  { time: "11:00", value: "11:00" },
  { time: "11:15", value: "11:15" },
  { time: "11:20", value: "11:20" },
  { time: "11:30", value: "11:30" },
  { time: "11:40", value: "11:40" },
  { time: "11:45", value: "11:45" },
  { time: "11:50", value: "11:50" },

  { time: "12:00", value: "12:00" },
  { time: "12:15", value: "12:15" },
  { time: "12:20", value: "12:20" },
  { time: "12:30", value: "12:30" },
  { time: "12:40", value: "12:40" },
  { time: "12:45", value: "12:45" },
  { time: "12:50", value: "12:50" },

  { time: "13:00", value: "13:00" },
  { time: "13:15", value: "13:15" },
  { time: "13:20", value: "13:20" },
  { time: "13:30", value: "13:30" },
  { time: "13:40", value: "13:40" },
  { time: "13:45", value: "13:45" },
  { time: "13:50", value: "13:50" },

  { time: "14:00", value: "14:00" },
  { time: "14:15", value: "14:15" },
  { time: "14:20", value: "14:20" },
  { time: "14:30", value: "14:30" },
  { time: "14:40", value: "14:40" },
  { time: "14:45", value: "14:45" },
  { time: "14:50", value: "14:50" },

  { time: "15:00", value: "15:00" },
  { time: "15:15", value: "15:15" },
  { time: "15:20", value: "15:20" },
  { time: "15:30", value: "15:30" },
  { time: "15:40", value: "15:40" },
  { time: "15:45", value: "15:45" },
  { time: "15:50", value: "15:50" },

  { time: "16:00", value: "16:00" },
  { time: "16:15", value: "16:15" },
  { time: "16:20", value: "16:20" },
  { time: "16:30", value: "16:30" },
  { time: "16:40", value: "16:40" },
  { time: "16:45", value: "16:45" },
  { time: "16:50", value: "16:50" },

  { time: "17:00", value: "17:00" },
  { time: "17:15", value: "17:15" },
  { time: "17:20", value: "17:20" },
  { time: "17:30", value: "17:30" },
  { time: "17:40", value: "17:40" },
  { time: "17:45", value: "17:45" },
  { time: "17:50", value: "17:50" },

  { time: "18:00", value: "18:00" },
  { time: "18:15", value: "18:15" },
  { time: "18:20", value: "18:20" },
  { time: "18:30", value: "18:30" },
  { time: "18:40", value: "18:40" },
  { time: "18:45", value: "18:45" },
  { time: "18:50", value: "18:50" },

  { time: "19:00", value: "19:00" },
  { time: "19:15", value: "19:15" },
  { time: "19:20", value: "19:20" },
  { time: "19:30", value: "19:30" },
  { time: "19:40", value: "19:40" },
  { time: "19:45", value: "19:45" },
  { time: "19:50", value: "19:50" },

  { time: "20:00", value: "20:00" },
  { time: "20:15", value: "20:15" },
  { time: "20:20", value: "20:20" },
  { time: "20:30", value: "20:30" },
  { time: "20:40", value: "20:40" },
  { time: "20:45", value: "20:45" },
  { time: "20:50", value: "20:50" },

  { time: "21:00", value: "21:00" },
  { time: "21:15", value: "21:15" },
  { time: "21:20", value: "21:20" },
  { time: "21:30", value: "21:30" },
  { time: "21:40", value: "21:40" },
  { time: "21:45", value: "21:45" },
  { time: "21:50", value: "21:50" },

  { time: "22:00", value: "22:00" },
  { time: "22:15", value: "22:15" },
  { time: "22:20", value: "22:20" },
  { time: "22:30", value: "22:30" },
  { time: "22:40", value: "22:40" },
  { time: "22:45", value: "22:45" },
  { time: "22:50", value: "22:50" },

  { time: "23:00", value: "23:00" },
  { time: "23:15", value: "23:15" },
  { time: "23:20", value: "23:20" },
  { time: "23:30", value: "23:30" },
  { time: "23:40", value: "23:40" },
  { time: "23:45", value: "23:45" },
  { time: "23:50", value: "23:50" },

  { time: "24:00", value: "00:00" },
  { time: "24:15", value: "00:15" },
  { time: "24:20", value: "00:20" },
  { time: "24:30", value: "00:30" },
  { time: "24:40", value: "00:40" },
  { time: "24:45", value: "00:45" },
  { time: "24:50", value: "00:50" },

  { time: "1:00", value: "01:00" },
  { time: "1:15", value: "01:15" },
  { time: "1:20", value: "01:20" },
  { time: "1:30", value: "01:30" },
  { time: "1:40", value: "01:40" },
  { time: "1:45", value: "01:45" },
  { time: "1:50", value: "01:50" },

  { time: "2:00", value: "02:00" },
  { time: "2:15", value: "02:15" },
  { time: "2:20", value: "02:20" },
  { time: "2:30", value: "02:30" },
  { time: "2:40", value: "02:40" },
  { time: "2:45", value: "02:45" },
  { time: "2:50", value: "02:50" },

  { time: "3:00", value: "03:00" },
  { time: "3:15", value: "03:15" },
  { time: "3:20", value: "03:20" },
  { time: "3:30", value: "03:30" },
  { time: "3:40", value: "03:40" },
  { time: "3:45", value: "03:45" },
  { time: "3:50", value: "03:50" },

  { time: "4:00", value: "04:00" },
  { time: "4:15", value: "04:15" },
  { time: "4:20", value: "04:20" },
  { time: "4:30", value: "04:30" },
  { time: "4:40", value: "04:40" },
  { time: "4:45", value: "04:45" },
  { time: "4:50", value: "04:50" },

  { time: "5:00", value: "05:00" },
  { time: "5:15", value: "05:15" },
  { time: "5:20", value: "05:20" },
  { time: "5:30", value: "05:30" },
  { time: "5:40", value: "05:40" },
  { time: "5:45", value: "05:45" },
  { time: "5:50", value: "05:50" },
];
const calculateEndDate = (startDate, numberOfDays) => {
  const newDate = new Date(startDate);
  newDate.setDate(newDate.getDate() + numberOfDays);
  newDate.setHours(23, 59, 59, 999);
  return newDate;
};
export const FormFirstStep = (formikProps) => {
  const {
    errors,
    touched,
    values,
    setFieldValue,
    isCreate,
    dayTimeState,
  } = formikProps;
  const { gym } = useSelector((state) => state.gym);
  const { court, bookingSlots,courtDurations } = useSelector((state) => state.court);
  const [deletedSlots, setDeletedSlots] = useState([]); 

  const [checkedDays, setCheckedDays] = useState({
    Saturday: false,
    Sunday: false,
    Monday: false,
    Tuesday: false,
    Wednesday: false,
    Thursday: false,
    Friday: false,
  });

  const [changer, setChanger] = useState(false);
  const dispatch = useDispatch();
  const [typesSdule, setTypeScdule] = useState({});

  const [courtSchedulingFillingType, setCourtSchedulingFillingType] = useState(
    "dayByDay"
  );
  const [showUpdateSlotsModal, setShowUpdateModal] = useState(false);
  const [showBookingList, setShowBookingList] = useState({
    show: false,
    bookings: [],
  });

  const [currentUpdatedInterval, setCurrentUdatedInterval] = useState({});
  const [intialUpdatedInterval, setIntialUpdatedInterval] = useState({});

  const [allDaysChecked, setAllDaysChecked] = useState(false);

  /** here for many types: */
  const [dayTimeStateByType, setDayTimeStateByType] = useState(null);
  /** here for many types: */

  const [tempTimeStateObject, setTempTimeStateObject] = useState({
    day: null,
    start: null,
    end: null,
    startIndex: null,
    endIndex: null,
  });

  const [deleteTimeState, setDeleteTimeState] = useState({
    day: null,
    timeIndex: null,
  });

  const [dateIntervals, setDateIntervals] = useState(
    formikProps.dateIntervals || []
  );
  const [deletedDateIntervals, setDeletedDateIntervals] = useState([]);
  const [newDateIntervals, setNewDateIntervals] = useState([]);
  const [currentInterval, setCurrentInterval] = useState({
    startDate: new Date(new Date().setHours(0, 0, 0, 0)).getTime(),
    endDate: calculateEndDate(new Date(), 30).getTime(),
    timeSlots: [],
    timeSlotsByType: [],
  });
  const [activeType, setActiveType] = useState("");
  const [allDaysCheckedByType, setAllDaysCheckedByType] = useState(null);
  const [checkedDaysByType, setCheckedDaysByType] = useState(null);

  const durationsList = useMemo(() => {
    return courtDurations.map((el)=>{return{
      label:el.duration,
      value:parseInt(el.duration)

    }})
  }, [
    courtDurations,
  ]);
  const [durationsSelected, setDurationsSelected] = useState([]);
  const [stepMinutes,setStepMinutes]=useState(null)  
  useEffect(() => {
    setTempTimeStateObject({ start: null, end: null });
  }, [courtSchedulingFillingType]);

  useEffect(() => {
    setFieldValue("dateIntervals", dateIntervals);
  }, [dateIntervals]);
  useEffect(() => {
    setFieldValue("newDateIntervals", newDateIntervals);
  }, [newDateIntervals]);
useEffect(()=>{

  setDurationsSelected(values.durationsSelected)
},[values.durationsSelected])
  useEffect(() => {
    setFieldValue("deletedDateIntervals", deletedDateIntervals);
  }, [deletedDateIntervals]);

  const handleTimeChange = () => {
    if (tempTimeStateObject.start && tempTimeStateObject.end) {
      const { start, end, day } = tempTimeStateObject;
      const tempDayTime = formikProps.dayTimeState;
      tempDayTime[`${day}`].push({
        start: timesArr[parseInt(start)].value,
        end: timesArr[parseInt(end)].value,
      });
      formikProps.setDayTimeState(tempDayTime);
      // Update currentInterval with new slots
      setCurrentInterval((prev) => ({
        ...prev,
        timeSlots: tempDayTime,
        timeSlotsByType: dayTimeStateByType,
      }));
      setTempTimeStateObject({ start: "", end: "", day: "" });
    }
  };
  const handleAddTimeSlot = () => {
    const { start, end } = tempTimeStateObject;
    if (start === null || end === null || start === "" || end === "") {
      alert("Please select both 'from' and 'to' times.");
      return;
    }
    const startIndex = parseInt(start);
    const endIndex = parseInt(end);
    if (isNaN(startIndex) || isNaN(endIndex)) {
      alert("Please select valid times.");
      return;
    }
    const updatedSlots = { ...formikProps.dayTimeState };
    Object.keys(checkedDays).forEach((day) => {
      if (checkedDays[day]) {
        if (!updatedSlots[day]) {
          updatedSlots[day] = [];
        }
        updatedSlots[day].push({
          start: timesArr[startIndex].value,
          end: timesArr[endIndex].value,
        });
      }
    });

    formikProps.setDayTimeState(updatedSlots);
    setTempTimeStateObject({ start: null, end: null });

    // Update currentInterval with new slots
    setCurrentInterval((prev) => ({
      ...prev,
      timeSlots: updatedSlots,
      timeSlotsByType: dayTimeStateByType,
    }));
  };

 const generateStartTimeAndEndByIntervalPeriod = () => {
    const { start, end } = tempTimeStateObject;

    if (start === null || end === null || start === "" || end === "") {
      alert("Please select both 'from' and 'to' times.");
      return [];
    }

    const startIndex = parseInt(start, 10);
    const endIndex = parseInt(end, 10);

    const startMoment = moment(timesArr[startIndex].value, "HH:mm");
    const endMoment = moment(timesArr[endIndex].value, "HH:mm");
    if (!startMoment.isValid() || !endMoment.isValid()) {
      alert("Please select valid times.");
      return [];
    }
    if (endIndex <= startIndex) {
      alert("End time must be after start time.");
      return [];
    }

    // The picker is ordered as one operational day (06:00 through 05:50).
    // Early-morning closing times therefore belong to the following day.
    if (!endMoment.isAfter(startMoment)) {
      endMoment.add(1, "day");
    }

    if (!durationsSelected || durationsSelected.length === 0) {
      alert("Please select interval(s)");
      return [];
    }

    // Parse all intervals to integers
    const intervals = durationsSelected.map(i => parseInt(i, 10)).filter(i => !isNaN(i) && i > 0);
    if (intervals.length === 0) {
      alert("Invalid interval(s)");
      return [];
    }

    const slotsByInterval = {};

    intervals.forEach(interval => {
      const slots = [];
      let current = startMoment.clone();
       const step = stepMinutes || interval; // if user didn’t select → step = interval

      while (current.isBefore(endMoment)) {
        const slotStart = current.clone();
        const slotEnd = slotStart.clone().add(interval, "minutes");

        if (slotEnd.isAfter(endMoment)) break;

        slots.push({
          start: slotStart.format("HH:mm"),
          end: slotEnd.format("HH:mm"),
        });

        current.add(step, "minutes");
      }

      slotsByInterval[interval] = slots; // store slots for this interval
    });


    // Optional: if you want to combine all intervals into one array
    const combinedSlots = Object.values(slotsByInterval).flat();

    const updatedSlots = { ...formikProps.dayTimeState };
    Object.keys(checkedDays).forEach((day) => {
      if (checkedDays[day]) {
        updatedSlots[day] = combinedSlots.map(s => ({ ...s })); // clone
      }
    });

    formikProps.setDayTimeState(updatedSlots);
    setTempTimeStateObject({ start: null, end: null });
    setFieldValue("durationsSelected",[])
    setStepMinutes(null)
    setCourtSchedulingFillingType("dayByDay")
    setCurrentInterval(prev => ({
      ...prev,
      timeSlots: updatedSlots,
      timeSlotsByType: dayTimeStateByType,
    }));
 };

  const isAddSlotButtonDisabled = () => {
    const { start, end } = tempTimeStateObject;

    // Check if courtSchedulingFillingType is multipleDays
    if (courtSchedulingFillingType !== "multipleDays"&&courtSchedulingFillingType!=="timeRange") {
      return true; // Disable the button if not in multipleDays mode
    }

    // Check if start or end times are not selected
    if (!start || !end) {
      return true;
    }

    // Check if start or end times are empty strings
    if (start === "" || end === "") {
      return true;
    }

    // Parse start and end as integers
    const startIndex = parseInt(start);
    const endIndex = parseInt(end);

    // Ensure start and end are valid indices
    if (isNaN(startIndex) || isNaN(endIndex)) {
      return true;
    }

    // Check if no day is selected
    if (Object.values(checkedDays).every((day) => !day)) {
      return true;
    }

    // If all conditions are satisfied, enable the button
    return false;
  };

  const resetDaysAndTimes = () => {
    formikProps.setDayTimeState({
      Saturday: [],
      Sunday: [],
      Monday: [],
      Tuesday: [],
      Wednesday: [],
      Thursday: [],
      Friday: [],
    });
    setCheckedDays({
      Saturday: false,
      Sunday: false,
      Monday: false,
      Tuesday: false,
      Wednesday: false,
      Thursday: false,
      Friday: false,
    });
    setAllDaysChecked(false);
    setCheckedDaysByType({
      ...checkedDaysByType,
      [activeType]: {
        Saturday: false,
        Sunday: false,
        Monday: false,
        Tuesday: false,
        Wednesday: false,
        Thursday: false,
        Friday: false,
      },
    });
    setAllDaysCheckedByType({ ...allDaysCheckedByType, [activeType]: false });
  };

  const handleCloseInterval = () => {
    if (currentInterval.startDate) {
      // Save the interval with associated time slots
      setDateIntervals([...dateIntervals, {...currentInterval,isPublished:values.isPublished}]);
      setNewDateIntervals([{...currentInterval,isPublished:values.isPublished}]);

      // Reset the current interval state for new entries
      setCurrentInterval({
        startDate: null,
        endDate: null,
        timeSlots: [],
        timeSlotsByType: [],
      });

      //reset days and times
      resetDaysAndTimes();

      setTempTimeStateObject({ start: null, end: null });
    } else {
      toastr.error("Please select start date.");
    }
  };

  React.useEffect(() => {
    if (tempTimeStateObject.start && tempTimeStateObject.end)
      handleTimeChange();
  }, [changer]);

  React.useEffect(()=>{
  dispatch(getCourtDurations());
    
  },[])
  function format24Hour(hours, minutes) {
    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}`;
  }
  React.useEffect(() => {
    if (deleteTimeState.day) {
      handleDeleteScheduleTime();
    }
  }, [deleteTimeState]);

  React.useEffect(() => {
    setFieldValue("scheduleDays", formikProps.dayTimeState);
  }, [formikProps.dayTimeState]);

  useEffect(() => {
    if (currentUpdatedInterval?.timeSlots) {
      // Create a completely new object

      const newTime = {
        Saturday: [],
        Sunday: [],
        Monday: [],
        Tuesday: [],
        Wednesday: [],
        Thursday: [],
        Friday: [],
      };

      // Then apply the updates from currentUpdatedInterval
      Object.keys(currentUpdatedInterval?.timeSlots).forEach((type) => {
        const checkedDays = currentUpdatedInterval?.timeSlots;

        Object.keys(checkedDays).forEach((day) => {
          const values = checkedDays[day];
          if (values.length) {
            newTime[day] = values;
          }
        });
      });

      // Set the completely new object
      // setCheckedDaysByType(newCheckedDaysByType);
      formikProps.setDayTimeState(newTime);
    }
  }, [currentUpdatedInterval]);
  React.useEffect(() => {
    if (bookingSlots.length) {
      setShowBookingList({ show: true, bookings: bookingSlots });
    } else {
      if (values.update) {
        dispatch(
          updateCourtSlots(court?.id, {
            updatedScheduleSlots: values.updatedScheduleSlots,
          })
        );
      }
    }
  }, [bookingSlots]);
  const handleDeleteScheduleTime = () => {
    const { day: deletedDay, timeIndex: time } = deleteTimeState;
    const timesArr = formikProps.dayTimeState;
    const deletedSlot = timesArr[deletedDay][time]; 
    if(deletedSlot){
      timesArr[`${deletedDay}`].splice(time, 1);
      formikProps.setDayTimeState(timesArr);
      setDeletedSlots(prev => [...prev, deletedSlot]);
      setChanger(!changer);
    }
  };
  const getTypes = async () => {
    return gym.type == "complex" && (await dispatch(getSlotsTypes()));
  };
  React.useEffect(() => {
    getTypes();
  }, []);

  return (
    <>
      <div className="trainer-info-wrapper info-wrapper border-bottom-1 blk-padding-y">
        <div className="info-title">
          <Title title={CourtContent.infotitle} />
        </div>
        <div className="info trainer-info">
          <Row>
            <Col md={6} className="mb-4 no-margin-on-mobile">
              <FormGroup className="custom-inputs mb-md-0">
                <Field
                  type="text"
                  name="name"
                  id="courtName"
                  maxLength={50}
                  placeholder={CourtContent.name}
                  className={`form-control ${errors.name &&
                    touched.name &&
                    "is-invalid"}`}
                />
                {errors.name && touched.name ? (
                  <div className="invalid-feedback">{`${errors.name}`}</div>
                ) : null}
                <Label for="firstname" className="">
                  {CourtContent.name}
                </Label>
              </FormGroup>
            </Col>
            <Col md={6} className="mb-4 no-margin-on-mobile">
              <FormGroup className="custom-inputs mb-md-0">
                <Input
                  type="select"
                  name="type"
                  id="courtType"
                  placeholder={"type"}
                  className={`form-control ${errors.type &&
                    touched.type &&
                    "is-invalid"}`}
                  onChange={(e) => setFieldValue("type", e.target.value)}
                  value={values.type}
                >
                  {gym.type == "sportClub" ? (
                    <>
                      <option value="tennis">Tennis</option>
                      <option value="padel">Padel</option>
                      <option value="football">Football</option>
                      <option value="basketball">Basketball</option>
                       <option value="pickleball">Pickleball</option>
                      <option value="tableTennis">Table Tennis</option>

                    </>
                  ) : (
                    <>
                      <option value="therapy">Therapy</option>
                      {/* <option value="sauna">Sauna</option> */}
                    </>
                  )}
                </Input>
                {errors.type && touched.type ? (
                  <div className="invalid-feedback">{`${errors.type}`}</div>
                ) : null}
                <Label> {CourtContent.type}</Label>
              </FormGroup>
            </Col>
          </Row>
        </div>
      </div>
      <div className="trainer-info-wrapper info-wrapper border-bottom-1 blk-padding-y">
        <div className="info-title">
          <Title
            title={gym.type == "sportClub" ? "Court Settings" : "Room Settings"}
          />
        </div>
        <div className="info trainer-info">
          <Row>
            {/* Restricted Schedule Toggle */}
            <Col md={6} className="mb-4">
              <FormGroup className="custom-inputs mb-md-0">
                <Label className="d-flex align-items-center">
                  <Input
                    type="checkbox"
                    checked={values.isRestricted}
                    onChange={(e) => {
                      setFieldValue("isRestricted", e.target.checked);
                    }}
                  />
                  <span className="ml-2">Restricted Schedule</span>
                </Label>
                {/* <small className="form-text text-muted">
                  Prevent overlapping bookings for different duration slots
                </small> */}
              </FormGroup>
            </Col>
          </Row>

          {/* Sub-locations Configuration */}

          {values.isRestricted && (
            <Row className="mt-3">
              <Col md={12}>
                <div className="alert alert-info">
                  With restricted scheduling enabled, longer duration slots will
                  be automatically hidden when shorter overlapping slots are
                  booked.
                </div>
              </Col>
            </Row>
          )}
        </div>
      </div>
      <div className="selction-box pt-4">
        <Title
          title="Scheduling"
          subtitle={`(${CourtContent.scheduling})`}
          titlestyle="pb-2"
        />
        <div className="mt-3 mb-3">
          {gym.type == "complex" ? (
            <TypeScheduleTabs
              formikProps={formikProps}
              gym={gym}
              courtSchedulingFillingType={courtSchedulingFillingType}
              setCourtSchedulingFillingType={setCourtSchedulingFillingType}
              dayTimeState={dayTimeState}
              setDayTimeState
              isAddSlotButtonDisabled={isAddSlotButtonDisabled}
              resetDaysAndTimes={resetDaysAndTimes}
              setFieldValue={setFieldValue}
              values={values}
              setDeleteTimeState={setDeleteTimeState}
              setChanger={setChanger}
              changer={changer}
              tempTimeStateObject={tempTimeStateObject}
              setTempTimeStateObject={setTempTimeStateObject}
              timesArr={timesArr}
              setCheckedDays={setCheckedDays}
              setAllDaysChecked={setAllDaysChecked}
              checkedDays={checkedDays}
              allDaysChecked={allDaysChecked}
              handleAddTimeSlot={handleAddTimeSlot}
              weekDays={weekDays}
              activeType={activeType}
              setActiveType={setActiveType}
              deleteTimeState={deleteTimeState}
              dayTimeStateByType={dayTimeStateByType}
              setDayTimeStateByType={setDayTimeStateByType}
              setCurrentInterval={setCurrentInterval}
              checkedDaysByType={checkedDaysByType}
              setAllDaysCheckedByType={setAllDaysCheckedByType}
              allDaysCheckedByType={allDaysCheckedByType}
              setCheckedDaysByType={setCheckedDaysByType}
              durationsList={durationsList}
              durationsSelected={durationsSelected}
              setDurationsSelected={setDurationsSelected}
              stepMinutes={stepMinutes}
              setStepMinutes={setStepMinutes}
              setDeletedSlots={setDeletedSlots}
            />
          ) : (
            <>
              <div className="status-inner-block mt-3 mb-4">
                Set Schedule For
                <div className="subscription-plan-list-element">
                  <div className="radio-perdays-package">
                    <div
                      className="form-check form-check-inline custom-btn-radio"
                      onChange=""
                    >
                      <Field
                        type="radio"
                        name="courtSchedulingFillingType"
                        id="dayByDay"
                        value="dayByDay"
                        className="form-check-input"
                        checked={courtSchedulingFillingType === "dayByDay"}
                        onClick={(e) => {
                          setCourtSchedulingFillingType(e.target.value);
                        }}
                      />

                      <label
                        className="form-check-label label-blk"
                        for="dayByDay"
                      >
                        Day By Day
                      </label>
                    </div>
                  </div>
                </div>
                <div className="subscription-plan-list-element">
                  <div className="">
                    <div
                      className="form-check form-check-inline custom-btn-radio"
                      checked
                      onChange=""
                    >
                      <Field
                        type="radio"
                        name="courtSchedulingFillingType"
                        id="multipleDays"
                        value="multipleDays"
                        className="form-check-input"
                        checked={courtSchedulingFillingType === "multipleDays"}
                        onClick={(e) => {
                          setCourtSchedulingFillingType(e.target.value);
                        }}
                      />
                      <label
                        className="form-check-label label-blk"
                        for="multipleDays"
                      >
                        Multiple Days
                      </label>
                    </div>
                  </div>
                </div>
                <div className="subscription-plan-list-element">
                  <div className="">
                    <div
                      className="form-check form-check-inline custom-btn-radio"
                      checked
                      onChange=""
                    >
                      <Field
                        type="radio"
                        name="courtSchedulingFillingType"
                        id="timeRange"
                        value="timeRange"
                        className="form-check-input"
                        checked={courtSchedulingFillingType === "timeRange"}
                        onClick={(e) => {
                          setCourtSchedulingFillingType(e.target.value);
                        }}
                      />
                      <label
                        className="form-check-label label-blk"
                        for="timeRange"
                      >
                        Time Range & Interval
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              {courtSchedulingFillingType === "multipleDays" && (
                <>
                  <div className="mt-5 mb-5">
                    <Row>
                      <Col md={4}>
                        <FormGroup className="custom-inputs select-box mb-md-0 times-container">
                          <Label for="multi-day-from">From</Label>
                          <Input
                            type="select"
                            name="multi-day-from"
                            id="multi-day-from"
                            value={tempTimeStateObject.start ?? ""}
                            key={`multi-day-from-${tempTimeStateObject.start}`}
                            placeholder="From"
                            onChange={(e) => {
                              const startValue = e.target.value;
                              setTempTimeStateObject((prevState) => ({
                                ...prevState,
                                start: startValue,
                              }));
                            }}
                          >
                            <option value="">Select Start Time</option>
                            {timesArr.map((time, index) => (
                              <option key={index} value={index}>
                                {time.time}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col md={4}>
                        <FormGroup className="custom-inputs select-box mb-md-0 times-container">
                          <Label for="multi-day-to">To</Label>
                          <Input
                            type="select"
                            name="multi-day-to"
                            id="multi-day-to"
                            value={tempTimeStateObject.end ?? ""}
                            key={`multi-day-to-${tempTimeStateObject.end}`}
                            placeholder="To"
                            onChange={(e) => {
                              const endValue = e.target.value;
                              setTempTimeStateObject((prevState) => ({
                                ...prevState,
                                end: endValue,
                              }));
                            }}
                          >
                            <option value="">Select End Time</option>
                            {timesArr.map((time, index) => (
                              <option key={index} value={index}>
                                {time.time}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col md={4}>
                        <button
                          onClick={handleAddTimeSlot}
                          disabled={isAddSlotButtonDisabled()}
                          type="button"
                          className="btn"
                        >
                          Add Slot
                        </button>
                      </Col>
                    </Row>
                  </div>
                </>
              )}
               {courtSchedulingFillingType === "timeRange" && (
                <>
                  <div className="mt-5 mb-5">
                    <Row>
                      <Col md={2}>
                        <FormGroup className="custom-inputs select-box mb-md-0 times-container">
                          <Label for="period-day-from">Start Period Time</Label>
                          <Input
                            type="select"
                            name="period-day-from"
                            id="period-day-from"
                            value={tempTimeStateObject.start ?? ""}
                            key={`period-day-from-${tempTimeStateObject.start}`}
                            placeholder="From"
                            onChange={(e) => {
                              const startValue = e.target.value;
                              setTempTimeStateObject((prevState) => ({
                                ...prevState,
                                start: startValue,
                              }));
                            }}
                          >
                            <option value="">Select Start Time</option>
                            {timesArr.map((time, index) => (
                              <option key={index} value={index}>
                                {time.time}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col md={2}>
                        <FormGroup className="custom-inputs select-box mb-md-0 times-container">
                          <Label for="period-day-to">End Period Time</Label>
                          <Input
                            type="select"
                            name="period-day-to"
                            id="period-day-to"
                            value={tempTimeStateObject.end ?? ""}
                            key={`period-day-to-${tempTimeStateObject.end}`}
                            placeholder="To"
                            onChange={(e) => {
                              const endValue = e.target.value;
                              setTempTimeStateObject((prevState) => ({
                                ...prevState,
                                end: endValue,
                              }));
                            }}
                          >
                            <option value="">Select End Time</option>
                            {timesArr.map((time, index) => (
                              <option key={index} value={index}>
                                {time.time}
                              </option>
                            ))}
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col md={3}>
                        <FormGroup className="custom-inputs select-box mb-md-0 times-container">
                        <MultiSelector
                            name="durationsSelected"
                            placeholder="Intervals (in minutes)"
                            data={durationsList}
                            handleChange={formikProps.setFieldValue}
                            selected={durationsSelected}
                          />
                        </FormGroup>
                      </Col>
                     <Col md={3}>
                        <FormGroup className="custom-inputs select-box mb-md-0 times-container">
                          <Label for="step-minutes">New Slot Every (optional)</Label>
                          <Input
                            type="select"
                            name="step-minutes"
                            id="step-minutes"
                            value={stepMinutes ?? ""}
                            onChange={(e) => setStepMinutes(e.target.value ? parseInt(e.target.value, 10) : null)}
                          >
                            <option value="">Default (same as duration)</option>
                            <option value="15">Every 15 min</option>
                            <option value="20">Every 20 min</option>
                            <option value="30">Every 30 min</option>
                            <option value="45">Every 45 min</option>
                            <option value="60">Every 60 min</option>
                          </Input>
                          <FormText>
                            If left empty, slots follow one after another (no overlapping).  
                            Example: With 60-min duration and “New Slot Every 30 min” → slots overlap.
                          </FormText>
                        </FormGroup>
                      </Col> 
                      <Col md={2}>
                        <button
                          onClick={generateStartTimeAndEndByIntervalPeriod}
                          disabled={isAddSlotButtonDisabled()}
                          type="button"
                          className="btn"
                        >
                          Add Slots
                        </button>
                      </Col>
                    </Row>
                  </div>
                </>
              )}
              <FormGroup className="schedule-checkboxes-list col-1" check>
                <Label check className="container-blk">
                  <Input
                    type="checkbox"
                    id="allDays"
                    onChange={(e) => {
                      setAllDaysChecked(e.target.checked);

                      if (e.target.checked) {
                        setCheckedDays({
                          Saturday: true,
                          Sunday: true,
                          Monday: true,
                          Tuesday: true,
                          Wednesday: true,
                          Thursday: true,
                          Friday: true,
                        });
                      } else {
                        //reset days and times
                        resetDaysAndTimes();
                      }
                    }}
                    checked={allDaysChecked}
                  />
                  All Days
                  <span className="checkmark"></span>
                </Label>
              </FormGroup>
              <ul className="schedule-checkbox-list-block mt-2">
                {weekDays.map((value, index) => {
                  const times = formikProps.dayTimeState || [];
                  const days = checkedDays;
                  return (
                    <Row
                      className={`schedule-row ${value.name}`}
                      style={{
                        backgroundColor: value.id % 2 === 0 ? "#f5f7f8" : "",
                      }}
                    >
                      <li className="schedule-checkbox-element">
                        <FormGroup className="schedule-checkboxes-list" check>
                          <Label check className="container-blk">
                            <Input
                              type="checkbox"
                              id={value.id}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  days[`${value.name}`] = true;
                                } else {
                                  setAllDaysChecked(false);
                                  days[`${value.name}`] = false;
                                  times[`${value.name}`] = [];
                                }
                                setCheckedDays(days);
                                formikProps.setDayTimeState(times);

                                setFieldValue(
                                  "scheduleDays",
                                  values.scheduleDays
                                );
                              }}
                              checked={days[`${value.name}`]}
                            />{" "}
                            {value.name}
                            <span className="checkmark"></span>
                          </Label>
                        </FormGroup>
                        <span
                          className="selected-times-outer-container"
                          style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(2,0.1fr)",
                          }}
                        >
                          {dayTimeState && (
                            <span className="selected-times-container ">
                              {dayTimeState[`${value.name}`].map(
                                (time, timeIndex) => {
                                  return (
                                    <span className="time-card-container">
                                      <span className="time-card-inner-container">
                                        <span className="time-card-texts">
                                          {time.start} - {time.end}
                                        </span>
                                        <span
                                          className="times-card-delete"
                                          onClick={() => {
                                            setDeleteTimeState({
                                              day: value.name,
                                              timeIndex: timeIndex,
                                            });
                                          }}
                                        >
                                          <img src={deletenew} />
                                        </span>
                                      </span>
                                    </span>
                                  );
                                }
                              )}
                              {courtSchedulingFillingType === "dayByDay" &&
                                days[`${value.name}`] && (
                                  <FormGroup className="custom-inputs select-box mb-md-0 times-container">
                                    <Input
                                      type="select"
                                      className={` times-dropdown time-from `}
                                      name={`times-${value.name}-from`}
                                      id={`${value.name}-times`}
                                      value={
                                        tempTimeStateObject.day === value.name
                                          ? tempTimeStateObject.start
                                          : ""
                                      }
                                      placeholder={"Court"}
                                      onChange={(e) => {
                                        setTempTimeStateObject({
                                          ...tempTimeStateObject,
                                          start: e.target.value,
                                          day: `${value.name}`,
                                        });
                                        setChanger(!changer);
                                      }}
                                    >
                                      <option value="">From</option>
                                      {tempTimeStateObject.end
                                        ? timesArr
                                            .slice(0, tempTimeStateObject.end)
                                            .map((time, timeIndex) => {
                                              return (
                                                <option
                                                  key={time.value}
                                                  value={timesArr.indexOf(time)}
                                                >
                                                  {time.time}
                                                </option>
                                              );
                                            })
                                        : timesArr.map((time, timeIndex) => {
                                            return (
                                              <option
                                                key={time.value}
                                                value={timeIndex}
                                              >
                                                {time.time}
                                              </option>
                                            );
                                          })}
                                    </Input>
                                    <Input
                                      type="select"
                                      placeholder="To"
                                      className={`form-control times-dropdown time-to`}
                                      name={`times-${value.name}-to`}
                                      value={tempTimeStateObject.end}
                                      id={`${value.name}-times `}
                                      onChange={(e) => {
                                        setTempTimeStateObject({
                                          ...tempTimeStateObject,
                                          end: e.target.value,
                                          day: `${value.name}`,
                                        });
                                        setChanger(!changer);
                                      }}
                                    >
                                      <option value="">To</option>
                                      {tempTimeStateObject.start
                                        ? timesArr
                                            .slice(
                                              parseInt(
                                                tempTimeStateObject.start
                                              ) + 1
                                            )
                                            .map((time, timeIndex) => {
                                              return (
                                                <option
                                                  key={time.value}
                                                  value={timesArr.indexOf(time)}
                                                >
                                                  {time.time}
                                                </option>
                                              );
                                            })
                                        : timesArr.map((time, timeIndex) => {
                                            return (
                                              <option
                                                key={time.value}
                                                value={timeIndex}
                                              >
                                                {time.time}
                                              </option>
                                            );
                                          })}
                                    </Input>
                                  </FormGroup>
                                )}
                            </span>
                          )}
                        </span>
                      </li>
                    </Row>
                  );
                })}
              </ul>
            </>
          )}
        </div>
           {/** Publish functionality */}

        <div className="">
          <Row className="mt-5">
            <Col md={12} className="mb-4">
    
              <FormGroup className="schedule-checkboxes-list" check>
                <Label check className="container-blk">
                  <Input
                    type="checkbox"
                    id="isPublished"
                    onChange={(e) => {
                      setFieldValue("isPublished", e.target.checked);
                    }}
                    checked={values.isPublished}
                  />
                  Publish Immediately
                  <span className="checkmark"></span>
                </Label>
              </FormGroup>
            </Col>
             <Col md={12}>
                <div className="alert alert-warning" style={{fontSize:"14px"}}>
                  When enabled publish immediately, the schedule will be immediately visible to members.
                  When disabled, the schedule will remain in draft mode until you choose to publish it.
                </div>
              </Col>
          </Row>
  
          
        </div>
        <DateIntervalPicker
          currentInterval={currentInterval}
          setCurrentInterval={setCurrentInterval}
          handleCloseInterval={handleCloseInterval}
          calculateEndDate={calculateEndDate}
        />
      </div>

      {dateIntervals.length > 0 && (
        <DateIntervalSummary
          setDateIntervals={setDateIntervals}
          dateIntervals={dateIntervals}
          setDeletedDateIntervals={setDeletedDateIntervals}
          deletedDateIntervals={deletedDateIntervals}
          setShowUpdateModal={setShowUpdateModal}
          setCurrentUdatedInterval={setCurrentUdatedInterval}
          setIntialUpdatedInterval={setIntialUpdatedInterval}
        />
      )}
      {showUpdateSlotsModal && (
        <Modal
          isOpen={showUpdateSlotsModal}
          centered={true}
          size={"xl"}
          className="large-pop adding-popup"
        >
          <ModalBody>
            <div className="bg-white mx-2">
              <div className="d-flex align-items-center border-bottom-1 pb-4 mb-4">
                <div className="d-inline-flex ">
                  <Title title="Update Slots schdeule" />
                </div>
                <div className="d-inline-flex ml-auto">
                  <div className="close-icons pb-0">
                    <div className="text-right">
                      <span
                        className="svg-block"
                        onClick={() => {
                          setShowUpdateModal(false);
                        }}
                      >
                        {ComonIcons.closeBlack}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <Card className="border-0 shadow-sm mb-4">
                <CardBody className="p-4">
                  {/* Header Section */}
                  <div className="mb-4">
                    <div className="d-flex align-items-center gap-3 mb-2">
                      <h5 className="mb-0 text-dark">Update Schedule Period</h5>
                    </div>
                    <p
                      className="text-secondary mb-0 mt-2"
                      style={{ fontSize: "0.9rem" }}
                    >
                      update the time period for your available scheduling slots
                    </p>
                  </div>

                  {/* Date Picker Section */}
                  <div className="date-interval-container bg-light rounded p-4">
                    <Row className="align-items-center">
                      <Col md={2}>
                        <h6 className="text-secondary mb-0">Date Range</h6>
                      </Col>

                      <Col md={3}>
                        <div className="position-relative">
                          <DatePicker
                            dateFormat="dd/MM/yyyy"
                            className="form-control border"
                            name="startDate"
                            placeholderText="From"
                            selected={
                              intialUpdatedInterval?.newStartDate
                                ? new Date(intialUpdatedInterval?.newStartDate)
                                : new Date(intialUpdatedInterval?.startDate)
                            }
                            onChange={(date) => {
                              if (
                                date.getTime() &&
                                intialUpdatedInterval?.newEndDate &&
                                intialUpdatedInterval?.newEndDate <
                                  date.getTime()
                              ) {
                                setIntialUpdatedInterval((prev) => ({
                                  ...prev,
                                  newStartDate: date
                                    ? new Date(date.getTime()).setHours(
                                        0,
                                        0,
                                        0,
                                        0
                                      )
                                    : null,
                                  newEndDate: calculateEndDate(
                                    date,
                                    30
                                  ).getTime(),
                                }));
                              } else {
                                setIntialUpdatedInterval((prev) => ({
                                  ...prev,
                                  newStartDate: date
                                    ? new Date(date.getTime()).setHours(
                                        0,
                                        0,
                                        0,
                                        0
                                      )
                                    : null,
                                }));
                              }
                            }}
                          />
                          <div
                            className="position-absolute"
                            style={{
                              right: "10px",
                              top: "50%",
                              transform: "translateY(-50%)",
                              pointerEvents: "none",
                            }}
                          >
                            <img
                              src={require("../../assets/images/date_range.svg")}
                              alt="calendar"
                              style={{ width: "18px", height: "18px" }}
                            />
                          </div>
                        </div>
                      </Col>

                      <Col md={3}>
                        <div className="position-relative">
                          <DatePicker
                            dateFormat="dd/MM/yyyy"
                            selected={
                              intialUpdatedInterval?.newEndDate
                                ? new Date(intialUpdatedInterval?.newEndDate)
                                : new Date(intialUpdatedInterval?.endDate)
                            }
                            minDate={
                              intialUpdatedInterval?.newStartDate
                                ? new Date(intialUpdatedInterval?.newStartDate)
                                : new Date(intialUpdatedInterval?.startDate)
                            }
                            className="form-control border"
                            name="endDate"
                            placeholderText="To"
                            onChange={(date) => {
                              setIntialUpdatedInterval((prev) => ({
                                ...prev,
                                newEndDate: date
                                  ? new Date(date.getTime()).setHours(
                                      0,
                                      0,
                                      0,
                                      0
                                    )
                                  : null,
                              }));
                            }}
                          />
                          <div
                            className="position-absolute"
                            style={{
                              right: "10px",
                              top: "50%",
                              transform: "translateY(-50%)",
                              pointerEvents: "none",
                            }}
                          >
                            <img
                              src={require("../../assets/images/date_range.svg")}
                              alt="calendar"
                              style={{ width: "18px", height: "18px" }}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </CardBody>
              </Card>
              <div className="selction-box pt-4">
                <div className="mt-3 mb-3">
                  {gym.type == "complex" ? (
                    <TypeScheduleTabs
                      formikProps={formikProps}
                      gym={gym}
                      courtSchedulingFillingType={courtSchedulingFillingType}
                      setCourtSchedulingFillingType={
                        setCourtSchedulingFillingType
                      }
                      dayTimeState={dayTimeState}
                      setDayTimeState
                      isAddSlotButtonDisabled={isAddSlotButtonDisabled}
                      resetDaysAndTimes={resetDaysAndTimes}
                      setFieldValue={setFieldValue}
                      values={values}
                      setDeleteTimeState={setDeleteTimeState}
                      setChanger={setChanger}
                      changer={changer}
                      tempTimeStateObject={tempTimeStateObject}
                      setTempTimeStateObject={setTempTimeStateObject}
                      timesArr={timesArr}
                      setCheckedDays={setCheckedDays}
                      setAllDaysChecked={setAllDaysChecked}
                      checkedDays={checkedDays}
                      allDaysChecked={allDaysChecked}
                      handleAddTimeSlot={handleAddTimeSlot}
                      weekDays={weekDays}
                      activeType={activeType}
                      setActiveType={setActiveType}
                      deleteTimeState={deleteTimeState}
                      dayTimeStateByType={dayTimeStateByType}
                      setDayTimeStateByType={setDayTimeStateByType}
                      setCurrentInterval={setCurrentInterval}
                      checkedDaysByType={checkedDaysByType}
                      setAllDaysCheckedByType={setAllDaysCheckedByType}
                      allDaysCheckedByType={allDaysCheckedByType}
                      setCheckedDaysByType={setCheckedDaysByType}
                      currentUpdatedInterval={currentUpdatedInterval}
                      edit={true}
                      durationsList={durationsList}
                      durationsSelected={durationsSelected}
                      setDurationsSelected={setDurationsSelected}
                      stepMinutes={stepMinutes}
                      setStepMinutes={setStepMinutes}
                      setDeletedSlots={setDeletedSlots}
                    />
                  ) : (
                    <>
                      <div className="status-inner-block mt-3 mb-4">
                        Set Schedule For
                        {/* <div className="subscription-plan-list-element">
                          <div className="radio-perdays-package">
                            <div
                              className="form-check form-check-inline custom-btn-radio"
                              onChange=""
                            >
                              <Field
                                type="radio"
                                name="courtSchedulingFillingType"
                                id="dayByDay"
                                value="dayByDay"
                                className="form-check-input"
                                checked={
                                  courtSchedulingFillingType === "dayByDay"
                                }
                                onClick={(e) => {
                                  setCourtSchedulingFillingType(e.target.value);
                                }}
                              />

                              <label
                                className="form-check-label label-blk"
                                for="dayByDay"
                              >
                                Day By Day
                              </label>
                            </div>
                          </div>
                        </div> */}
                        <div className="subscription-plan-list-element">
                          <div className="">
                            <div
                              className="form-check form-check-inline custom-btn-radio"
                              checked
                              onChange=""
                            >
                              <Field
                                type="radio"
                                name="courtSchedulingFillingType"
                                id="multipleDays"
                                value="multipleDays"
                                className="form-check-input"
                                checked={
                                  courtSchedulingFillingType === "multipleDays"
                                }
                                onClick={(e) => {
                                  setCourtSchedulingFillingType(e.target.value);
                                }}
                              />
                              <label
                                className="form-check-label label-blk"
                                for="multipleDays"
                              >
                                Multiple Days
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      {courtSchedulingFillingType === "multipleDays" && (
                        <>
                          <div className="mt-5 mb-5">
                            <Row>
                              <Col md={4}>
                                <FormGroup className="custom-inputs select-box mb-md-0 times-container">
                                  <Label for="multi-day-from">From</Label>
                                  <Input
                                    type="select"
                                    name="multi-day-from"
                                    id="multi-day-from"
                                    value={tempTimeStateObject.start ?? ""}
                                    key={`multi-day-from-${tempTimeStateObject.start}`}
                                    placeholder="From"
                                    onChange={(e) => {
                                      const startValue = e.target.value;
                                      setTempTimeStateObject((prevState) => ({
                                        ...prevState,
                                        start: startValue,
                                      }));
                                    }}
                                  >
                                    <option value="">Select Start Time</option>
                                    {timesArr.map((time, index) => (
                                      <option key={index} value={index}>
                                        {time.time}
                                      </option>
                                    ))}
                                  </Input>
                                </FormGroup>
                              </Col>
                              <Col md={4}>
                                <FormGroup className="custom-inputs select-box mb-md-0 times-container">
                                  <Label for="multi-day-to">To</Label>
                                  <Input
                                    type="select"
                                    name="multi-day-to"
                                    id="multi-day-to"
                                    value={tempTimeStateObject.end ?? ""}
                                    key={`multi-day-to-${tempTimeStateObject.end}`}
                                    placeholder="To"
                                    onChange={(e) => {
                                      const endValue = e.target.value;
                                      setTempTimeStateObject((prevState) => ({
                                        ...prevState,
                                        end: endValue,
                                      }));
                                    }}
                                  >
                                    <option value="">Select End Time</option>
                                    {timesArr.map((time, index) => (
                                      <option key={index} value={index}>
                                        {time.time}
                                      </option>
                                    ))}
                                  </Input>
                                </FormGroup>
                              </Col>
                              <Col md={4}>
                                <button
                                  onClick={handleAddTimeSlot}
                                  disabled={isAddSlotButtonDisabled()}
                                  type="button"
                                  className="btn"
                                >
                                  Add Slot
                                </button>
                              </Col>
                            </Row>
                          </div>
                        </>
                      )}
                      <FormGroup
                        className="schedule-checkboxes-list col-1"
                        check
                      >
                        <Label check className="container-blk">
                          <Input
                            type="checkbox"
                            id="allDays"
                            onChange={(e) => {
                              setAllDaysChecked(e.target.checked);

                              if (e.target.checked) {
                                setCheckedDays({
                                  Saturday: true,
                                  Sunday: true,
                                  Monday: true,
                                  Tuesday: true,
                                  Wednesday: true,
                                  Thursday: true,
                                  Friday: true,
                                });
                              } else {
                                setCheckedDays({
                                  Saturday: false,
                                  Sunday: false,
                                  Monday: false,
                                  Tuesday: false,
                                  Wednesday: false,
                                  Thursday: false,
                                  Friday: false,
                                });
                                setAllDaysChecked(false);
                              }
                            }}
                            checked={allDaysChecked}
                          />
                          All Days
                          <span className="checkmark"></span>
                        </Label>
                      </FormGroup>
                      <ul className="schedule-checkbox-list-block mt-2">
                        {weekDays.map((value, index) => {
                          const times = formikProps.dayTimeState || [];
                          const days = checkedDays;
                          return (
                            <Row
                              className={`schedule-row ${value.name}`}
                              style={{
                                backgroundColor:
                                  value.id % 2 === 0 ? "#f5f7f8" : "",
                              }}
                            >
                              <li className="schedule-checkbox-element">
                                <FormGroup
                                  className="schedule-checkboxes-list"
                                  check
                                >
                                  <Label check className="container-blk">
                                    <Input
                                      type="checkbox"
                                      id={value.id}
                                      onChange={(e) => {
                                        if (e.target.checked) {
                                          days[`${value.name}`] = true;
                                        } else {
                                          setAllDaysChecked(false);
                                          days[`${value.name}`] = false;
                                          times[`${value.name}`] = [];
                                        }
                                        setCheckedDays(days);
                                        formikProps.setDayTimeState(times);

                                        setFieldValue(
                                          "scheduleDays",
                                          values.scheduleDays
                                        );
                                      }}
                                      checked={days[`${value.name}`]}
                                    />{" "}
                                    {value.name}
                                    <span className="checkmark"></span>
                                  </Label>
                                </FormGroup>
                                <span
                                  className="selected-times-outer-container"
                                  style={{
                                    display: "grid",
                                    gridTemplateColumns: "repeat(2,0.1fr)",
                                  }}
                                >
                                  {dayTimeState && (
                                    <span className="selected-times-container ">
                                      {dayTimeState[`${value.name}`].map(
                                        (time, timeIndex) => {
                                          return (
                                            <span className="time-card-container">
                                              <span className="time-card-inner-container">
                                                <span className="time-card-texts">
                                                  {time.start} - {time.end}
                                                </span>
                                                <span
                                                  className="times-card-delete"
                                                  onClick={() => {
                                                    setDeleteTimeState({
                                                      day: value.name,
                                                      timeIndex: timeIndex,
                                                    });
                                                  }}
                                                >
                                                  <img src={deletenew} />
                                                </span>
                                              </span>
                                            </span>
                                          );
                                        }
                                      )}
                                      {courtSchedulingFillingType ===
                                        "dayByDay" &&
                                        days[`${value.name}`] && (
                                          <FormGroup className="custom-inputs select-box mb-md-0 times-container">
                                            <Input
                                              type="select"
                                              className={` times-dropdown time-from `}
                                              name={`times-${value.name}-from`}
                                              id={`${value.name}-times`}
                                              value={
                                                tempTimeStateObject.day ===
                                                value.name
                                                  ? tempTimeStateObject.start
                                                  : ""
                                              }
                                              placeholder={"Court"}
                                              onChange={(e) => {
                                                setTempTimeStateObject({
                                                  ...tempTimeStateObject,
                                                  start: e.target.value,
                                                  day: `${value.name}`,
                                                });
                                                setChanger(!changer);
                                              }}
                                            >
                                              <option value="">From</option>
                                              {tempTimeStateObject.end
                                                ? timesArr
                                                    .slice(
                                                      0,
                                                      tempTimeStateObject.end
                                                    )
                                                    .map((time, timeIndex) => {
                                                      return (
                                                        <option
                                                          key={time.value}
                                                          value={timesArr.indexOf(
                                                            time
                                                          )}
                                                        >
                                                          {time.time}
                                                        </option>
                                                      );
                                                    })
                                                : timesArr.map(
                                                    (time, timeIndex) => {
                                                      return (
                                                        <option
                                                          key={time.value}
                                                          value={timeIndex}
                                                        >
                                                          {time.time}
                                                        </option>
                                                      );
                                                    }
                                                  )}
                                            </Input>
                                            <Input
                                              type="select"
                                              placeholder="To"
                                              className={`form-control times-dropdown time-to`}
                                              name={`times-${value.name}-to`}
                                              value={tempTimeStateObject.end}
                                              id={`${value.name}-times `}
                                              onChange={(e) => {
                                                setTempTimeStateObject({
                                                  ...tempTimeStateObject,
                                                  end: e.target.value,
                                                  day: `${value.name}`,
                                                });
                                                setChanger(!changer);
                                              }}
                                            >
                                              <option value="">To</option>
                                              {tempTimeStateObject.start
                                                ? timesArr
                                                    .slice(
                                                      parseInt(
                                                        tempTimeStateObject.start
                                                      ) + 1
                                                    )
                                                    .map((time, timeIndex) => {
                                                      return (
                                                        <option
                                                          key={time.value}
                                                          value={timesArr.indexOf(
                                                            time
                                                          )}
                                                        >
                                                          {time.time}
                                                        </option>
                                                      );
                                                    })
                                                : timesArr.map(
                                                    (time, timeIndex) => {
                                                      return (
                                                        <option
                                                          key={time.value}
                                                          value={timeIndex}
                                                        >
                                                          {time.time}
                                                        </option>
                                                      );
                                                    }
                                                  )}
                                            </Input>
                                          </FormGroup>
                                        )}
                                    </span>
                                  )}
                                </span>
                              </li>
                            </Row>
                          );
                        })}
                      </ul>
                    </>
                  )}
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-medium"
              onClick={() => {

                let updatedScheduleSlots = {
                  ...currentUpdatedInterval,
                  previousStartDate: intialUpdatedInterval.startDate,
                  previousEndDate: intialUpdatedInterval.endDate,
                  timeSlotsByType: values?.scheduleDaysByType,
                  timeSlots: values?.scheduleDaysByType
                    ? null
                    : currentUpdatedInterval?.timeSlots,
                  startDate: intialUpdatedInterval?.newStartDate
                    ? intialUpdatedInterval?.newStartDate
                    : intialUpdatedInterval?.startDate,
                  endDate: intialUpdatedInterval?.newEndDate
                    ? intialUpdatedInterval?.newEndDate
                    : intialUpdatedInterval.endDate,
                };

                dispatch(
                  getBookingsForUpdatedSlots(court.id, { updatedScheduleSlots,deletedSlots })
                );
                setFieldValue("updatedScheduleSlots", updatedScheduleSlots);
                setFieldValue("update", true);

                // dispatch(
                //   updateCourtSlots(court?.id, {
                //     updatedScheduleSlots,
                //   })
                // );
                setShowUpdateModal(false);
              }}
            >
              Save Changes
            </button>
          </ModalFooter>
        </Modal>
      )}
      {showBookingList.show && (
        <Modal
          isOpen={showBookingList.show}
          centered={true}
          size={"lg"}
          className="large-pop adding-popup"
        >
          <ModalHeader
            toggle={() => setShowBookingList({ show: false, bookings: [] })}
            className="border-bottom"
          >
            <span className="fw-bold">Affected Bookings</span>
          </ModalHeader>

          <ModalBody className="p-4">
            <div className="text-center mb-4">
              <h5 className=" fw-normal" style={{ color: "rgb(202 15 15)" }}>
                The following bookings will be affected by your slot updates
              </h5>
            </div>

            <div className="table-responsive border rounded">
              <Table hover bordered className="mb-0">
                <thead className="bg-light">
                  <tr>
                    <th className="py-2">Name</th>
                    <th className="py-2">Time</th>
                    <th className="py-2">Day</th>
                    <th className="py-2">Booking Date</th>
                  </tr>
                </thead>
                <tbody>
                  {showBookingList.bookings.map((booking, index) => (
                    <tr key={booking.id || index}>
                      <td>{booking?.member?.name || "N/A"}</td>
                      <td>
                        {booking.courtSlot.start}-{booking.courtSlot.end}
                      </td>
                      <td>{booking.courtSlot.day}</td>
                      <td>
                        {moment(booking.bookingDate).format("DD/MM/YYYY")}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>

            <Alert color="warning" className="mt-4 mb-0">
              <div className="d-flex align-items-center mb-2">
                <i className="fa fa-exclamation-triangle me-2"></i>
                <h5 className="mb-0">
                  Warning: Existing Bookings Will Be Affected
                </h5>
              </div>

              <p className="mb-2">
                This slot update will affect{" "}
                <strong>
                  {showBookingList.bookings.length} existing bookings
                </strong>{" "}
                across your schedule.
              </p>

              <p className="mb-2">
                You must either{" "}
                <strong>early cancel these bookings first</strong> before
                updating the slots, or{" "}
                <strong>keep the current slot configuration</strong> to maintain
                these bookings.
              </p>

              <div className=" p-2 rounded">
                <p className="mb-0 small" style={{ color: "rgb(202 15 15)" }}>
                  <strong>Note:</strong> Cancelling bookings will notify your
                  clients and may impact their plans.
                </p>
              </div>
            </Alert>
          </ModalBody>

          <ModalFooter className="border-top d-flex justify-content-between">
            <Button
              color="outline-secondary"
              onClick={() => {
                setShowBookingList({ show: false, bookings: [] });
              }}
            >
              Keep Current Configuration
            </Button>

            <Button
              color="danger"
              onClick={() => {
                // dispatch(
                //   earlyCancelAllBookingsForUpdatedSlots(
                //     showBookingList.bookings.map((el) => el.id)
                //   )
                // );
                history.push("/gym-panel/bookings/courts");
                setShowBookingList({ show: false, bookings: [] });
              }}
            >
              Manual Early Cancel Bookings & Update
            </Button>
          </ModalFooter>
        </Modal>
      )}
    </>
  );
};
